<template>
  <div id="app">
    <template v-if="this.$route.name === 'Dashboard' || this.$route.name === 'FamilyMembers' || this.$route.name === 'EditParishioner'">
      <dash-nav></dash-nav>
    </template>
    <template v-else>
      <nav-bar></nav-bar>
    </template>
    <router-view></router-view>
    <template v-if="this.$route.name === 'Dashboard' || this.$route.name === 'FamilyMembers' || this.$route.name === 'EditParishioner'">
      <dash-foot></dash-foot>
    </template>
    <template v-else>
      <footer-bar></footer-bar>
    </template>
  </div>
</template>

<script>
  import NavBar from "./components/NavBar";
  import footerBar from "./components/footerBar";
  import DashNav from "./components/dashboard/DashNav";
  import DashFooter from "./components/dashboard/DashFooter";

  export default {
    name: 'app',
    data(){
      return {}
    },
    components: {
      'nav-bar': NavBar,
      'footer-bar': footerBar,
      'dash-nav': DashNav,
      'dash-foot': DashFooter
    },
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
  }
</style>